define('shared/remote/util/MemberLeadPayloadCreator',[
    'shared/lib/RSVP',
    'shared/page/language',
    'shared/page/market',
    'shared/page/partner'
], function(
    RSVP,
    getLanguage,
    getMarket,
    getPartner
){

    function removeNullOrUndefinedProps(obj) {
        for(var key in obj) {
            if (!obj.hasOwnProperty(key) || obj[key] != null) {
                continue;
            }
            delete obj[key];
        }
    }

    function Ctor() {

    }

    Ctor.prototype.create = function (options, additionalOptions) {
        return RSVP.resolve()
            .then(function(){
                if (additionalOptions && additionalOptions.noAutoRetrieve === true)  {
                    return RSVP.resolve([]);
                }
                return RSVP.all([getMarket(), getLanguage(), getPartner()]);
            })
            .then(function(values){
                var market = values[0];
                var language = values[1];
                var partner = values[2];

                var data = {
                    Country: options.market || market,
                    Language: options.language || language,
                    Partner: options.partner || partner,

                    LeadType: options.lead && options.lead.type,

                    Email: options.email,
                    FirstName: options.name && options.name.given,
                    LastName: options.name && options.name.family,

                    MemberType: options.member && options.member.type,
                    StudentType: options.student && options.student.type,

                    Telephone: options.phones && options.phones.telephone,
                    HomePhone: options.phones && options.phones.home,
                    WorkPhone: options.phones && options.phones.work,
                    MobilePhone: options.phones && options.phones.mobile,
                    AgeGroup: options.ageGroup,
                    Etag: options.etag,
                    Gender: options.gender,
                    DateOfBirth: options.date && options.date.birth,
                    Address1: options.addresses && options.addresses[0],
                    Address2: options.addresses && options.addresses[1],
                    LocalName: options.userSelectedMarket,
                    City: options.city,
                    State: options.state,
                    PostalCode: options.postcode,
                    Occupation: options.occupation,
                    CallTime: options.callTime,
                    
                    LearnReason: options.survey && options.survey.learnReason,
                    Proficiency: options.survey && options.survey.proficiency,
                    Industry: options.survey && options.survey.industry,
                    EnglishLevel: options.survey && options.survey.englishLevel,
                    
                    Title: options.title,
                    
                    SourcePageName: options.tracking && 
                        options.tracking.sourcePage && 
                        options.tracking.sourcePage.name,
                    SourceSystemName: options.tracking && 
                        options.tracking.sourceSystem && 
                        options.tracking.sourceSystem.name,
                    HasOffersTransactionId: options.tracking && options.tracking.hasOffersTransactionId,
                    GoogleClickId: options.tracking && options.tracking.google.clickId,
                    MarinClickId: options.tracking && options.tracking.marin.clickId,
                    UtmSource: options.tracking && options.tracking.utm.source,
                    UtmMedium: options.tracking && options.tracking.utm.medium,
                    UtmCampaign: options.tracking && options.tracking.utm.campaign,
                    UtmTerm: options.tracking && options.tracking.utm.term,
                    UtmContent: options.tracking && options.tracking.utm.content,
                    UtmAdGroup: options.tracking && options.tracking.utm.adGroup,
                    GAClientId: options.tracking && options.tracking.ga.clientId,
                    AdobeVisitorId: options.tracking && options.tracking.adobe.visitorId,

                    ReferredBy: options.referred && options.referred.by,
                    ReferredFrom: options.referred && options.referred.from,
                    ReferrerUrl: options.referrer,

                    SubscribeToPartnerPromo: options.subscriptions && options.subscriptions.partnerPromo,
                    SubscribeToDailyLesson: options.subscriptions && options.subscriptions.dailyLesson,
                    SubscribeToMarketCampaign: options.subscriptions && options.subscriptions.etPromo
                };

                removeNullOrUndefinedProps(data);

                return data;
            });
    };

    Ctor.instance = new Ctor();

   return Ctor;
});

// {
//   "Lead_id": 0,
//   "LeadType": "string",
//   "InsertDate": "2018-08-07T10:23:12.675Z",
//   "UpdateDate": "2018-08-07T10:23:12.675Z",
//   "EFId": "string",
//   "StudentId": "string",
//   "SourcePageName": "string",
//   "SourceSystemName": "string",
//   "FirstName": "string",
//   "LastName": "string",
//   "Email": "string",
//   "Telephone": "string",
//   "HomePhone": "string",
//   "WorkPhone": "string",
//   "MobilePhone": "string",
//   "AgeGroup": "string",
//   "Country": "string",
//   "Partner": "string",
//   "Etag": "string",
//   "Language": "string",
//   "Gender": "string",
//   "DateOfBirth": "2018-08-07T10:23:12.675Z",
//   "Address1": "string",
//   "Address2": "string",
//   "City": "string",
//   "State": "string",
//   "PostalCode": "string",
//   "Occupation": "string",
//   "LocalName": "string",
//   "LearnReason": "string",
//   "Proficiency": "string",
//   "Industry": "string",
//   "Title": "string",
//   "HasOffersTransactionId": "string",
//   "GoogleClickId": "string",
//   "MarinClickId": "string",
//   "TradeDoublerUId": "string",
//   "EFGuid": "string",
//   "UtmSource": "string",
//   "UtmMedium": "string",
//   "UtmCampaign": "string",
//   "UtmTerm": "string",
//   "UtmContent": "string",
//   "UtmAdGroup": "string",
//   "GAClientId": "string",
//   "AdobeVisitorId": "string",
//   "CallTime": "string",
//   "Region": "string",
//   "StudyFocus": "string",
//   "Campaign": "string",
//   "WorkDistrict": "string",
//   "WantCall": true,
//   "StudyMotivation": "string",
//   "StudyFrequency": "string",
//   "CompanyName": "string",
//   "NumberOfStaff": 0,
//   "JobFunction": "string",
//   "JobSeniority": "string",
//   "HeardAboutUs": "string",
//   "AreasToImprove": "string",
//   "PreferredLocation": "string",
//   "AcademicQualification": "string",
//   "InternetSpeed": "string",
//   "DeviceType": "string",
//   "DeviceOS": "string",
//   "SearchEngineCode": "string",
//   "SearchEngineKeyword": "string",
//   "TestScore": "string",
//   "Description": "string",
//   "EnglishLevel": "string",
//   "PayMethod": "string",
//   "StaffEmail": "string",
//   "ReferredBy": 0,
//   "ReferredFrom": "string",
//   "EFSETTestLevel": "string",
//   "FacebookQuestion1": "string",
//   "FacebookAnswer1": "string",
//   "FacebookQuestion2": "string",
//   "FacebookAnswer2": "string",
//   "FacebookQuestion3": "string",
//   "FacebookAnswer3": "string",
//   "SubscribeToPartnerPromo": true,
//   "SubscribeToDailyLesson": true,
//   "SubscribeToMarketCampaign": true,
//   "SubscribeToStudyPlanEmail": true
// };
